module.exports = __webpack_public_path__ + "img/单据权限.75bbf921.svg";